module.exports = __webpack_public_path__ + "static/img/customer11.23234f7b.png";